export default __webpack_public_path__ + "static/media/GLINT.a78ca3ce.png";